export default "__VITE_ASSET__sbyOWlDT__"